import React from "react";
import PropTypes from "prop-types";

import { Item } from "../Item/Item";

export function MemberRole({ members, defaultMembers, roleName, onClick }) {
  const abbreviateName = ({ name }) => {
    if (!name) return "";

    const arr = name.trim().replace(/^\./, "").split(" ");
    if (arr.length === 1) {
      return arr[0];
    }

    return `${arr[0]} ${arr[arr.length - 1][0]}.`;
  };

  const fullName = ({ name }) => {
    return name;
  };

  if (members?.length === 0 && defaultMembers?.length === 0)
    return (
      <Item
        data-test="member-row"
        clickable
        text={roleName}
        subtext="Unassigned"
        onClick={onClick}
      />
    );

  if (members?.length > 0)
    return (
      <Item
        data-test="member-row"
        clickable
        title={members?.map(fullName)?.join(", ")}
        text={roleName}
        subtext={members?.map(abbreviateName)?.join(", ")}
        color="#000000de"
        onClick={onClick}
      />
    );

  return (
    <Item
      data-test="member-row"
      clickable
      text={roleName}
      subtext={defaultMembers?.map(abbreviateName)?.join(", ")}
      onClick={onClick}
      tooltipTitle={
        defaultMembers?.length > 1
          ? "These are the Default Settings Role assignees"
          : "This is the Default Settings Role assignee"
      }
    />
  );
}

MemberRole.propTypes = {
  members: PropTypes.array,
  defaultMembers: PropTypes.array,
  roleName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

MemberRole.defaultProps = {
  members: [],
  defaultMembers: [],
  roleName: "",
};

export default MemberRole;
